import { LookbookSectionFormHeading } from '@app/components/lookbook/LookbookSettingsPage/components';
import { Box, Edit, Menu } from '@app/components/various/Icons';
import { SidebarLayout } from '@app/components/various/SidebarLayout';
import { compiledPaths } from '@app/paths';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'lookbookSettings';

interface Props {
  activePath: string;
  hasChanges?: boolean;
  isDisabled?: boolean;
  isSubmitting?: boolean;
  onReset?: () => void;
  formName?: string;
  hasActionButtons?: boolean;
  lookbookId?: string;
  onSubmit?: () => void;
}

export const LookbookSettingsLayout = ({
  children,
  activePath,
  hasChanges = false,
  isDisabled,
  isSubmitting,
  onReset,
  formName,
  hasActionButtons = true,
  lookbookId,
  onSubmit,
}: React.WithChildren<Props>) => {
  const { t } = useTranslation(['lookbook']);

  const settingsNavigation = [
    {
      icon: Box,
      link: compiledPaths.LOOKBOOK_SINGLE_SETTINGS_GENERAL({ lookbookId }),
      subtitle: t('lookbook:navigation.general.subtitle'),
      title: t('lookbook:navigation.general.title'),
    },
    {
      icon: Menu,
      link: compiledPaths.LOOKBOOK_SINGLE_SETTINGS_NAVIGATION({ lookbookId }),
      subtitle: t('lookbook:navigation.navigation.subtitle'),
      title: t('lookbook:navigation.navigation.title'),
    },
    {
      icon: Edit,
      link: compiledPaths.LOOKBOOK_SINGLE_SETTINGS_CRITERIA({ lookbookId }),
      subtitle: t('lookbook:navigation.criteria.subtitle'),
      title: t('lookbook:navigation.criteria.title'),
    },
  ];

  return (
    <div className="px-4 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <LookbookSectionFormHeading
          lookbookId={lookbookId}
          headingLink={compiledPaths.LOOKBOOK_SINGLE({ lookbookId })}
          hasChanges={hasChanges}
          isDisabled={isDisabled}
          isSubmitting={isSubmitting}
          onReset={onReset}
          formName={formName}
          hasActionButtons={hasActionButtons}
          onSubmit={onSubmit}
        />
        <SidebarLayout storageKey={STORAGE_KEY} navigationItems={settingsNavigation} activePath={activePath}>
          {children}
        </SidebarLayout>
      </div>
    </div>
  );
};
